import type { Token } from '@creator/sdk/modules/token/token.model';
import type { CommentSortOrder, Post } from '@src/store/contentEntities/model';
// import { getCommentSortPreference } from './commentSort';

export function getEffectiveCommentSortOrder(tokenName: string, post: Post | undefined, token: Token | undefined): CommentSortOrder {
    // Priority 1: User's manual selection (localStorage) - per token
    // const userPreference = getCommentSortPreference(tokenName);
    // if (userPreference) return userPreference;

    // Priority 2: Post-specific sort setting
    if (post?.commentSort) return post.commentSort;

    // Priority 3: Token default setting
    if (token?.defaultCommentSort) return token.defaultCommentSort;

    // Priority 4: Global platform default
    return 'best';
}
